export default __webpack_public_path__ + "static/media/wedding6.3fe7194c.webp";